import TipSpoilService from '@/services/requests/tipSpoilService'
export default {
  computed: {
    filteredTips() {
      if (!this.batch.spoilId) return this.tips
      return this.tips.filter(tip => {
        return !!this.tipSpoils.filter(combination => {
          return combination.tipId == tip.id && combination.spoilId == this.batch.spoilId
        }).length
      })
    }
  },
  asyncComputed: {
    tipSpoils: {
      default: [],
      get() {
        return TipSpoilService.getTipSpoilsById(this.batch.spoilId, 'spoil').then(result => {
          //console.log(result.data.result)
          return result.data.result;
        }).catch(err => {
          this.snackError()
          console.log(err);
          return []
        });
      },
    }
  },
}